export const set = (key, value) => {
    sessionStorage.setItem(key, JSON.stringify(value))
}

export const get = (key) => {
    const getted = sessionStorage.getItem(key);
    if(getted) {
        return JSON.parse(getted);
    } else {
        return null;
    }
}
